<div class="row">
  <div class="col-12">
    <!-- <div class="row">
            <div class="col-12">
                <h1 class="mb-4">{{title}}:</h1>
            </div>
            <div class="col-6 d-flex ">
                <div class="custom-input-wrap">
                    <mat-label class="label">Search</mat-label>
                    <mat-form-field class="custom-input" appearance="outline">
                        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
                    </mat-form-field>
                </div>
            </div>

            <div class="col-6 d-flex justify-content-end align-items-center">
                <div class="action-buttons-wrapper g-smaller-btn align-content-center align-items-center d-flex gap-4 justify-content-start mt-auto pb-4">
                    <button mat-stroked-button (click)="navigateToAdd()" class="g-btn g-tertiary-btn">Add {{title}}</button>
                </div>
            </div>

        </div> -->
    <div class="glap-breadcrumb mb-2">
      <div class="row">
        <div class="col-12">
          <h1 class="welcome-title font-size-32">{{ title }}</h1>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6 d-inline-flex ">
        <div class="custom-input-wrap">
          <mat-label class="label">Search </mat-label>
          <mat-form-field class="custom-input" appearance="outline">
            <input
              matInput
              (keyup)="applyFilter($event)"
              placeholder="Ex. Mia"
              #input
            />
          </mat-form-field>
        </div>

        <div
        *ngIf="addBtn"
          class="action-buttons-wrapper g-smaller-btn align-content-center align-items-center d-flex gap-4 ms-4 justify-content-start mt-auto pb-4"
        >
          <button
            mat-stroked-button
            class="g-btn g-secondary-btn"
            (click)="navigateToAdd()"
          >
            Add {{ title }}
          </button>
        </div>

        <div
        *ngIf="isDownloadBtnShow"
          class="action-buttons-wrapper g-smaller-btn align-content-center align-items-center d-flex gap-4 ms-4 justify-content-start mt-auto pb-4">
          <button mat-stroked-button class="g-btn g-secondary-btn" (click)="onDownload()">Download</button>
        </div>
      </div>

      <div class="col-6 d-flex justify-content-end">
        <!-- <div
        *ngIf="exportExcel"  class="action-buttons-wrapper g-smaller-btn align-content-center align-items-center d-flex gap-4 justify-content-start mt-auto pb-4 mx-2">
         <button mat-stroked-button (click)="exportDataToExcel()" class="g-btn g-tertiary-btn">Export Excel</button>
       </div> -->
        <div class="custom-input-wrap mx-2" *ngIf="isTypeFilter">
          <mat-label class="label">Location Type Filter </mat-label>
          <mat-form-field class="custom-input" appearance="outline">
            <mat-select
              placeholder="Select"
              name="typefilter"
              [(ngModel)]="typefilter"
              (selectionChange)="changeCropyear('typeFilter')"
            >
              <mat-option value="">All</mat-option>
              <mat-option value="warehouse">Warehouse</mat-option>
              <mat-option value="buyingcenter">Buying Center</mat-option>
              <mat-option value="pbm">PBM</mat-option>
            </mat-select>
            <mat-icon matSuffix color="primary" class="icons-font-size"
              >keyboard_arrow_down
            </mat-icon>
          </mat-form-field>
        </div>
        <div class="custom-input-wrap mx-2" *ngIf="isLocation">
          <mat-label class="label">Warehouse </mat-label>
          <mat-form-field class="custom-input" appearance="outline">
            <mat-select
              placeholder="Select"
              name="locationId"
              [(ngModel)]="locationId"
              (selectionChange)="changeCropyear('location')"
            >
              <mat-option value="">All</mat-option>
              <mat-option
                *ngFor="let warehouse of warehouses"
                [value]="warehouse.LocationId"
                >{{ warehouse?.WarehouseName }} - {{ warehouse?.WarehouseCode }}
              </mat-option>
            </mat-select>
            <mat-icon matSuffix color="primary" class="icons-font-size"
              >keyboard_arrow_down
            </mat-icon>
          </mat-form-field>
        </div>
        <div class="custom-input-wrap mx-2" *ngIf="isGodown">
          <mat-label class="label">Godown </mat-label>
          <mat-form-field class="custom-input" appearance="outline">
            <mat-select
              placeholder="Select"
              name="godownId"
              [(ngModel)]="godownId"
              (selectionChange)="changeCropyear('godown')"
            >
              <mat-option value="">All</mat-option>
              <mat-option
                *ngFor="let warehouse of godownlists"
                [value]="warehouse.godownId"
              >
                {{ warehouse?.godownName }}
              </mat-option>
            </mat-select>
            <mat-icon matSuffix color="primary" class="icons-font-size"
              >keyboard_arrow_down
            </mat-icon>
          </mat-form-field>
        </div>
        <div class="custom-input-wrap" *ngIf="isAtiveFilter">
          <mat-label class="label">Filter</mat-label>
          <mat-form-field class="custom-input" appearance="outline">
            <mat-select
              placeholder="Select"
              name="filter"
              [(ngModel)]="filter"
              (selectionChange)="changeCropyear('filter')"
            >
              <mat-option value="all">All</mat-option>
              <mat-option value="active">Active</mat-option>
              <mat-option value="inactive">Inactive</mat-option>
            </mat-select>
            <mat-icon matSuffix color="primary" class="icons-font-size"
              >keyboard_arrow_down</mat-icon
            >
          </mat-form-field>
        </div>

        <div class="custom-input-wrap" *ngIf="cropYearShow">
          <mat-label class="label">Year</mat-label>
          <mat-form-field class="custom-input" appearance="outline">
            <mat-select
              placeholder="Select"
              name="filter"
              [(ngModel)]="year"
              (selectionChange)="changeCropyear('year')"
            >
              <mat-option
                *ngFor="let yearsList of yearsLists"
                [value]="yearsList"
                >{{ yearsList }}
              </mat-option>
            </mat-select>
            <mat-icon matSuffix color="primary" class="icons-font-size"
              >keyboard_arrow_down</mat-icon
            >
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="g-custom-table-wrapper mb-5">
      <!-- matSort
        (matSortChange)="announceSortChange($event)" -->

      <table
        mat-table
        class="w-100"
        *ngIf="!isLoading"
        [dataSource]="dataSource"
      >
        <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

        <!-- name Column -->
        <div *ngFor="let col of displayedColumns; let i = index">
          <ng-container matColumnDef="{{ col }}">
            <!--  mat-sort-header sortActionDescription="Sort by  " -->
            <th mat-header-cell *matHeaderCellDef>{{ col }}</th>
            <td mat-cell *matCellDef="let element">
              {{ element | map : list : i }}
            </td>
          </ng-container>
        </div>

        <!-- Action Column -->
        <ng-container *ngIf="action" matColumnDef="Action">
          <th mat-header-cell *matHeaderCellDef>Action</th>
          <td mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              color="primary"
              [routerLink]="addAddress"
              [queryParams]="{ data: getId(element) }"
              aria-label="Edit record"
            >
              <mat-icon>edit_outline</mat-icon>
            </button>

            <!-- <button mat-icon-button color="primary" (click)="delete(getId(element))"
            aria-label="Edit record">
            <mat-icon>delete</mat-icon>
          </button> -->
          </td>
        </ng-container>

        <!-- Action Column -->
        <!-- <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> Action </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button color="warn" aria-label="Delete record">
                            <mat-icon>delete_outline</mat-icon>
                        </button>
                    </td>
                </ng-container> -->

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <!-- <div class="mt-3 noRecord" *ngIf="!isLoading && notFound">No record found</div> -->

      <mat-paginator
        [pageSizeOptions]="[20, 30, 40]"
        showFirstLastButtons
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
    </div>
    <div class="w-100 d-flex justify-content-center">
      <mat-spinner
        *ngIf="isLoading"
        class="loader-spinner white-spinner"
        [diameter]="30"
        [strokeWidth]="1"
      ></mat-spinner>
    </div>
  </div>
</div>
